<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_3_' + this.id]">
    <BackGround @audio="reemitAudio" @keypressed="highlight" />
    <Transition @audio="reemitAudio" />
    <MessageWriting @audio="reemitAudio" />
    <MessageView @audio="reemitAudio" />
    <Interface ref="interface" class="interface mx-auto" @audio="reemitAudio" @talkie="reemitTalkie" />
    <Lecture @audio="reemitAudio" />
  </div>
</template>

<script>
import BackGround from "@/components/immersion03/jeu_ballon/Background";
import Interface from "@/components/immersion03/jeu_ballon/Interface";
import Transition from "@/components/immersion03/jeu_ballon/Transition";
import Lecture from "@/components/immersion03/jeu_ballon/lecturePaysage";
import MessageWriting from "@/components/immersion03/jeu_ballon/MessageWrite";
import MessageView from "@/components/immersion03/jeu_ballon/MessageView";

export default {
  name: "IM_3_2",
  data: function () {
    return {
      id: 3
    };
  },
  methods: {
    reemitAudio: function (event) {
      this.$emit("audio", event);
    },
    highlight(key) {
      this.$refs.interface.highlight(key);
    },
    reemitTalkie(event) {
      this.$emit("talkie", event);
    }
  },
  components: { BackGround, Interface, Transition, MessageWriting, MessageView, Lecture },
  mounted() {
    this.$store.dispatch("changeState", "PLAY");
  }
};
</script>

<style scoped lang="scss">
.interface {
  position: absolute;
  bottom: 0;
}
</style>
